import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import * as Vivus from "vivus";

export default class extends Controller {
  static targets = [ "navicon", "naviconLine", "overlay", "megaMenu", "megaMenuInner", "menu", "mobileNavDrawer" ]

  initialize() {
    // console.log("Hello, Stimulus!", this.element)
    this.setupNaviconTl()
    this.setupOverlayTl()
    this.setupMegaMenuTl()
    this.setupMenuTls()
    this.setupMobileNavDrawers()
    this.megaMenuActive = false
    this.setupMainActionTls()
    this.setupLandscapeNavTls()
  }

  setupLandscapeNavTls(){
    const landscapeLinks = this.element.querySelectorAll('.logo, .landscape-nav a')
    landscapeLinks.forEach((link)=>{
      const linkTl = gsap.timeline({
        paused:true
      })
      .to(link.querySelector('span'),{
        yPercent:-100,
        autoAlpha:0,
        duration:.25
      })
      .set(link.querySelector('span'),{
        yPercent:100
      })
      .to(link.querySelector('span'),{
        yPercent:0,
        autoAlpha:1,
        duration:.25
      })
  
      link.addEventListener('mouseenter',()=>{
        if(!linkTl.isActive()){
          linkTl.progress(0).play()
        }
      })
    })
  }

  setupMainActionTls(){
    this.mainActions = this.element.querySelectorAll('.main-actions li')
    this.mainActions.forEach((el)=>{
      const svg = el.querySelector('svg')
      const svgPath = new Vivus(svg,{
        start:'manual'
      })
      svgPath.setFrameProgress(1)
      el.addEventListener('mouseenter',()=>{
        svgPath.stop().reset().play(2);
      })
    })
    // const myVivus = new Vivus('my-svg-id');
    // myVivus.stop().reset().play(2);
  }

  setupMenuTls(){
    // console.log(this.menuTargets)
    this.menuTls = new Array()
    this.menuTargets.forEach((el,i)=>{
      this.menuTls[i] = gsap.timeline({
        paused:true
      })
      .from(el,{
        autoAlpha:0,
        duration:.25
      })
    })
  }

  setupMobileNavDrawers(){
    this.mobileNavDrawerTls = new Array()
    this.mobileNavDrawerTargets.forEach((el,i)=>{
      this.mobileNavDrawerTls[i] = gsap.timeline({
        paused:i == 0 ? false : true
      })
      .to(el,{
        height:this.mobileNavDrawerTarget.closest('ul').offsetHeight - (this.mobileNavDrawerTarget.offsetHeight*3),
        duration:.25
      },'same')
      .to(el.querySelector('svg'),{
         rotation:45,
         duration:.25
      },'same')
    })
  }

    toggleMobileNavDrawer(event){
      const elm = event.target.closest('li')
      const getNodeindex = elm => [...elm.parentNode.children].findIndex(c => c == elm)

      const index = getNodeindex(elm)

      // const activate = (i) =>{
      //   gsap.to(this.mobileNavDrawerTargets[i].querySelector('svg'),.25,{
      //     rotation:45
      //   })
      // }

      // const deactivate = (i) => {
      //   gsap.to(this.mobileNavDrawerTargets[i].querySelector('svg'),.25,{
      //     rotation:0
      //   })
      // }

      this.mobileNavDrawerTls.forEach((tl, i)=>{
        if(i == index){
          tl.play()
          // activate(i)
        }else{
          // deactivate(i)
          tl.reverse()
        }
      })
    }


  setupMegaMenuTl(){
    this.megaMenuTl = gsap.timeline({
      paused:true,
      onStart:()=>{
        this.toggleOverlay()
      },
      onReverseComplete:()=>{
        this.toggleOverlay()
        gsap.set(this.megaMenuInnerTarget,{
          height:0
        })
      }
    })
    .from(this.megaMenuInnerTarget,{
      yPercent:-100,
      duration:.25
    })
  }

  setupNaviconTl(){
    const centerY = (this.naviconTarget.offsetHeight*.5) - 1
    this.naviconTl = gsap.timeline({
      paused:true
    })
    .to(this.naviconLineTargets[1],.125,{
      y:centerY
    },'move')
    .to(this.naviconLineTargets[2],.125,{
      y:centerY
    },'move')
    .set(this.naviconLineTargets[0],{
      autoAlpha:0
    })
    .to(this.naviconLineTargets[1],.125,{
      rotation:45
    },'rotate')
    .to(this.naviconLineTargets[2],.125,{
      rotation:-45
    },'rotate')
  }

  setupOverlayTl(){
    this.overlayTl = gsap.timeline({
      paused:true
    })
    .fromTo(document.querySelector('.overlay'),{
      autoAlpha:0
    },{
      autoAlpha:1,
      duration:.25
    })
  }

  toggleOverlay(){
    if(!this.overlayTl.progress()){
      this.overlayTl.play()
      this.lockScroll()
    }else{
      this.overlayTl.reverse()
      this.unlockScroll()
    }
  }

  showSearchPanel(){
    this.dispatch("showSearchPanel")
    this.toggleOverlay()
  }

  toggleMegaMenu(event){
    event.preventDefault()
    if(this.overlayTl.isActive() && !this.megaMenuTl.isActive()){
      return false
    }
    const closestLinkEl = event.target.closest('a')
    const closestListEl = event.target.closest('li')
    const menuTitle = closestLinkEl.dataset.title
    
    if(!this.megaMenuActive && !this.megaMenuTl.isActive()){
      this.megaMenuTl.play()
      this.megaMenuActive = true
      this.currentMegaMenu = menuTitle

      if(this.currentMegaMenu == 'shop'){
        gsap.set(this.megaMenuInnerTarget,{
          height:this.menuTargets[0].offsetHeight
        })
      }else{
        gsap.set(this.megaMenuInnerTarget,{
          height:this.menuTargets[1].offsetHeight
        })
      }

    }else if(this.megaMenuActive && this.currentMegaMenu == menuTitle && !this.megaMenuTl.isActive()){
      this.hideMegaMenu()
    }else{
      this.currentMegaMenu = menuTitle
    }

    if(this.currentMegaMenu == 'shop'){
      this.menuTls[0].play()
      this.menuTls[1].reverse()
      gsap.to(this.megaMenuInnerTarget,{
        height:this.menuTargets[0].offsetHeight,
        duration:.25
      })
    }else{
      this.menuTls[0].reverse()
      this.menuTls[1].play()
      gsap.to(this.megaMenuInnerTarget,{
        height:this.menuTargets[1].offsetHeight,
        duration:.25
      })
    }
  }

  hideMegaMenu(){
    if(!this.megaMenuTl.isActive()){
      this.megaMenuActive = false
      this.currentMegaMenu = false
      this.megaMenuTl.reverse()
      this.menuTls.forEach((el, i)=>{
        el.reverse()
      })
    }
  }

  toggleMobileNav(){
    this.dispatch("toggleMobileNav")
    if(!this.naviconTl.progress()){
      this.naviconTl.play()
      this.lockScroll()
    }else{
      this.naviconTl.reverse()
      this.unlockScroll()
    }
  }

  lockScroll(){
    const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}`;
  }

  unlockScroll(){
    const body = document.body;
    const scrollY = body.style.top;
    body.style.position = '';
    body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);

    window.addEventListener('scroll', () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });
  }

}